import { render, staticRenderFns } from "./infolist-item.vue?vue&type=template&id=3da3e516&scoped=true&"
import script from "./infolist-item.vue?vue&type=script&lang=js&"
export * from "./infolist-item.vue?vue&type=script&lang=js&"
import style0 from "./infolist-item.vue?vue&type=style&index=0&id=3da3e516&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da3e516",
  null
  
)

export default component.exports